'use client'
/** Nav cart trigger with a live item-count badge. Opens the global drawer. */
import { useCart } from '@/lib/cart/CartContext'
import { useLanguage } from '@/lib/context/LanguageContext'

export default function CartButton({ className = '' }: { className?: string }) {
  const { cart, open } = useCart()
  const { t } = useLanguage()
  const count = cart.count

  return (
    <button
      type="button"
      onClick={open}
      aria-label={t.nav.cart}
      className={
        'focus-ring relative inline-flex h-11 w-11 items-center justify-center text-ink hover:text-accent transition-colors ' +
        className
      }
    >
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" />
        <path d="M3 6h18" />
        <path d="M16 10a4 4 0 0 1-8 0" />
      </svg>
      {count > 0 && (
        <span className="absolute -right-0.5 -top-0.5 inline-flex min-w-[18px] items-center justify-center rounded-full bg-action px-1 text-[11px] font-bold leading-[18px] text-surface tabular-nums">
          {count.toLocaleString('fa-IR')}
        </span>
      )}
    </button>
  )
}
